import React, { useEffect, useState } from 'react';
import {
  Link
} from "react-router-dom";
import Photo from '../Image/BG.jpg';
import './Sura.css';
const Sura = () => {
    const[Data,setData]= useState([]);
    useEffect(()=>{
        fetch('https://api.quran.gading.dev/surah')
        .then(data=>data.json())
        .then(data=>console.log(setData(data)))
        console.log(Data)
        // console.log(Data.data[0].name.transliteration.en)
        // console.log(Data.data[0].name.transliteration.en)
        //   console.log(Data.data.map(data=>data.name.long))
        
    },[])
    const[search,setSearch]=useState("");
    return (
        <div>
         
        <section className="services">
  <div className="services-title text-center">
  <input className='searchbar' type="text" placeholder='Surah....' 
          onChange={(event)=>{setSearch(event.target.value);}}
          />
  </div>

  <div className="section-center clearfix">
{
Data.data&&  Data.data.filter((data)=>{
  if(search===""){
    return data;
  }
  else if(data.name.transliteration.en?.toLowerCase().includes(search?.toLowerCase())){
      return data;
  }

}).map((data,key)=>
 <Link to={`Surah/${data.number}`}>
    <article className="service-card" key={key}>
   
      <div className="service-img-container">

        <img src={Photo} className="service-img" alt="" />

        <span className="service-icon">
          <i className="fas fa-mortar-pestle fa-fw"></i>
        </span>
      </div>

      <div className="service-info">
    
        <h4 className="service-info-title">
          {data.name.long}
         
        </h4>
        <h4 className="service-info-title">
          {data.name.transliteration.en}
         
        </h4>
     
       
       
      </div>
    </article>

    </Link>
)}

  </div>
</section>
    </div>
    );
};

export default Sura;